import { lazy } from 'react'

const Dashboard = lazy(() => import('@/pages/Dashboard'))

const dashboardRoute = {
  path: 'dashboard',
  element: <Dashboard />,
  meta: { title: '仪表盘', icon: 'DashboardOutlined', permission: 'dashboard:view' },
}

export default dashboardRoute
